import Top from "./Top";
import Middle from "./Middle";
import Footer from "./Footer";

import main from "../assets/main.jpg";
import testimonial_1 from "../assets/testimonial_1.jpg";
import testimonial_2 from "../assets/testimonial_2.jpg";
import testimonial_3 from "../assets/testimonial_3.jpg";
import testimonial_4 from "../assets/testimonial_4.jpg";
import testimonial_5 from "../assets/testimonial_5.jpg";
import testimonial_6 from "../assets/testimonial_6.jpg";
import testimonial_7 from "../assets/testimonial_7.jpg";
import testimonial_8 from "../assets/testimonial_8.jpg";

const Body = () => {
  return (
    <div className="pt-24">
      <Top image={main} />
      <Middle />
      <Footer
        testimonials={[
          testimonial_1,
          testimonial_2,
          testimonial_3,
          testimonial_4,
          testimonial_5,
          testimonial_6,
          testimonial_7,
          testimonial_8,
        ]}
      />
    </div>
  );
};

export default Body;
